<template>
  <nav class="navbar navbar-expand-lg navbar-dark" style="background-color:#461227">
    <div class="container d-flex flex-column align-items-center">
      <a href="https://sarasch.com/" target="_blank" class="navbar-brand font-weight-light" style="margin-right:0rem">
        <img src="/img/logo_header.png" class="d-inline-block align-top" alt="Logo Sara Schenirer Application">
      </a>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import LocaleDropdown from './LocaleDropdown'

export default {
  name: 'NavBar',

  components: {
    LocaleDropdown
  },

  data: () => ({
    appName: window.config.appName
  }),

  computed: mapGetters({
    user: 'auth/user'
  }),

  methods: {
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>
.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -.375rem 0;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Navbar.vue